import {
  DATA_IMPORT_OPPORTUNITY,
  DATA_IMPORT_SCHEMA,
  DATA_IMPORT,
  DATA_IMPORT_RESHAPE,
} from "./actionType";

import { call, put, takeLatest } from "redux-saga/effects";

import {
  dataImportOpportunitySuccess,
  dataImportOpportunityFailure,
  dataImportSchemaSuccess,
  dataImportSchemaFailure,
  dataImportSuccess,
  dataImportFailure,
  dataImportReshapeSuccess,
  dataImportReshapeFailure,
} from "./action";

import {
  importOpportunityApiCall,
  callDataImportSchemaApi,
  callDataImportApi,
  callDataImportReshapeApi,
} from "../../helpers/fakebackend_helper";

function* dataImportOpportunitySaga(action) {
  try {
    const response = yield call(importOpportunityApiCall, action.payload);
    yield put(dataImportOpportunitySuccess(response));
  } catch (error) {
    yield put(dataImportOpportunityFailure(error));
  }
}

function* dataImportSchemaSaga() {
  try {
    const response = yield call(callDataImportSchemaApi);
    yield put(dataImportSchemaSuccess(response));
  } catch (error) {
    yield put(dataImportSchemaFailure(error?.message || error));
  }
}

function* dataImportSaga(action) {
  try {
    const response = yield call(callDataImportApi, action.payload);
    yield put(dataImportSuccess(response));
  } catch (error) {
    yield put(dataImportFailure(error?.message || error));
  }
}

function* dataImportReshapeSaga(action) {
  try {
    const response = yield call(callDataImportReshapeApi, action.payload);
    // FetchAPI returns the parsed body even on a non-2xx (it doesn't throw), so
    // surface a backend error (e.g. AI/parse failure) as a proper failure rather
    // than a "success" the UI can't act on.
    const ok = response && Array.isArray(response.Headers);
    if (ok) {
      yield put(dataImportReshapeSuccess(response));
    } else {
      const msg =
        response?.message ||
        response?.Message ||
        "AI reshape failed. Please adjust your instruction and try again.";
      yield put(dataImportReshapeFailure(msg));
    }
  } catch (error) {
    yield put(dataImportReshapeFailure(error?.message || error));
  }
}

export default function* DataImportSaga() {
  yield takeLatest(DATA_IMPORT_OPPORTUNITY, dataImportOpportunitySaga);
  yield takeLatest(DATA_IMPORT_SCHEMA, dataImportSchemaSaga);
  yield takeLatest(DATA_IMPORT, dataImportSaga);
  yield takeLatest(DATA_IMPORT_RESHAPE, dataImportReshapeSaga);
}
